import React from 'react'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const App = props => {
    const { ownCentered } = props
    return (
        <div className={`${ownCentered ? '' : 'loading'}`}>
            <Spin indicator={<LoadingOutlined spin />} />
        </div>
    )
}

export default App
